import { CALL_API } from 'redux-api-middleware';
import { requestLogout } from './actions';
import types from './types';

const { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE } = types;

function loginUser(creds) {
  return {
    [CALL_API]: {
      endpoint: `/api/v1/auth/login?email=${creds.email}&password=${creds.password}`,
      method: 'get',
      types: [LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE],
    },
  };
}

export default {
  loginUser,
  logoutUser: requestLogout,
};



// WEBPACK FOOTER //
// ./src/state/ducks/auth/operations.js